import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { P } from '../../../../typography/semanticTags';

export interface LinkButtonDataProps {
    text: string;
    onClick: string;
}

export interface LinkButtonThemeProps {
    color: string;
    hoverColor: string;
}

type LinkButtonProps = LinkButtonDataProps & LinkButtonThemeProps;

const createStyle = (color: string, hoverColor: string) => StyleSheet.create({
  button: {
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'start',
    color,
    ':hover': {
      color: hoverColor,
    },
    ':active': {
      color,
    },
    ':visited': {
      color,
    },
    ':focus': {
      outline: 'none',
    },
  },
});

export const LinkButton: React.FunctionComponent<LinkButtonProps> = props => {
  const { text, onClick, color, hoverColor } = props;
  /* eslint-disable-next-line no-new-func */
  const onClickFunction = new Function(onClick);
  const style = createStyle(color, hoverColor);
  return (
    <button type="button" onClick={() => onClickFunction()} className={css(style.button)}>
      <P>{text}</P>
    </button>
  );
};
